import { Button, ButtonProps } from 'antd';

const TransparentButton = (props: ButtonProps) => (
  <Button {...props} type="text" className={`${props.className} hover:bg-transparent cursor-default`} />
);

export default TransparentButton;
